import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { companyBySlugQueryOptions } from '@/entities/company'
import { useSession } from '@/entities/session'
import type { Crumb } from '@/shared/ui/breadcrumb'
import { DOC_TABS, DocumentPageView } from '../-ui/document-page'

const DocSearchSchema = z.object({
  tab: z.enum(DOC_TABS).optional().catch(undefined),
})

// Документ компании открывают обе роли: заказчик читает док своей компании
// (backend read-путь customer-capable), крошки строятся по роли.
export const Route = createFileRoute('/_app/companies/$company_/documents/$doc')({
  validateSearch: (search) => DocSearchSchema.parse(search),
  head: () => ({ meta: [{ title: 'Документ · STIT Deal' }] }),
  component: CompanyDocumentPage,
})

function CompanyDocumentPage() {
  const { company, doc } = Route.useParams()
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()
  const { session } = useSession()
  const isEmployee = session?.kind === 'employee'

  const companyQ = useQuery(companyBySlugQueryOptions(company))
  const c = companyQ.data

  // Заказчику список «Компании» недоступен — его крошки начинаются с компании.
  const ancestors: Crumb[] = [
    ...(isEmployee ? [{ label: 'Компании', to: '/companies' } as Crumb] : []),
    { label: c?.name ?? company, to: '/companies/$company', params: { company } },
    {
      label: 'Документы',
      to: '/companies/$company',
      params: { company },
      search: { tab: 'docs' },
    },
  ]

  return (
    <DocumentPageView
      documentId={doc}
      breadcrumbAncestors={ancestors}
      activeTab={tab ?? 'file'}
      onTabChange={(value) => void navigate({ search: { tab: value } })}
      onDeleted={() =>
        void navigate({ to: '/companies/$company', params: { company }, search: { tab: 'docs' } })
      }
    />
  )
}
